<template>
  <div class="product-widget">
    <v-layout justify-start wrap align-start>
      <strong>{{ $t('orderType') }}: {{ orderType ? $t('MPS') : $t('generalOrder') }}</strong>
    </v-layout>
    <v-layout v-if="storeName" justify-start wrap align-start>
      <strong>{{ $t('storeName') }}: {{ storeName }}</strong>
    </v-layout>
    <v-layout v-if="orderId" justify-start wrap align-start>
      <span>{{ $t('orderId') }}: {{ orderId }}</span>
        <v-icon 
          color="info"
          small 
          @click.stop="showErrorPopup" 
          v-if="messages && messages.length"
        >info</v-icon>
    </v-layout>
    <v-layout v-if="buyerName" justify-start wrap align-start>
      <span>{{ $t('buyerName') }}: {{ buyerName }}</span>
    </v-layout>
    <v-layout v-if="platform" justify-start wrap align-start>
      <span>{{ $t('platform') }}: {{ platform }}</span>
    </v-layout>
    <v-layout v-if="orderStatus" justify-start wrap align-start>
      <span style="color: red; font-weight: bold">{{ $t('orderStatus') }}: {{ $t(orderStatus) }}</span>
    </v-layout>
    <LabelErrorPopup v-if="messages && messages.length" :title="$t('orderErrorLog')" v-model="errorPop" :messages="messages || []" />
  </div>
</template>

<script>
import LabelErrorPopup from '@/components/LabelErrorPopup'

export default {
  name: 'OrderDetail',
  components: {LabelErrorPopup},
  data () {
    return {
      errorPop: false
    }
  },
  computed: {
    noteStyle () {
      return 'overflow-wrap: break-word; white-space: pre-wrap;' + (this.$vuetify.breakpoint.smAndDown 
        ? 'max-width: 15vw;' 
        : (this.$vuetify.breakpoint.mdOnly 
          ? 'max-width: 20vw;' 
          : (this.$vuetify.breakpoint.lgOnly 
            ? 'max-width: 30vw;' 
            : 'max-width: 40vw;')))
    }
  },
  methods: {
    showErrorPopup () {
      this.errorPop = true
    }
  },
  props: {
    orderId: String | Number,
    buyerName: String,
    platform: String,
    messages: Array,
    storeName: String,
    orderStatus: String,
    orderType: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.product-widget .long-item {
  max-width: 640px;
  overflow-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderDetail.vue